var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"course-lessons-list row"},_vm._l((_vm.lessons),function(lesson,i){return _c('div',{key:i,staticClass:"col-lg-3 col-md-6 py-3"},[_c('router-link',{staticClass:"text-decoration-none text-light align-items-center",attrs:{"to":{
        name: 'lesson',
        params: {
          ..._vm.course,
          lesson: lesson.id,
          id: _vm.courseId
        }
      }}},[_c('div',{staticClass:"img",style:(`background-image: url(${_vm.picture(lesson)})`),attrs:{"src":_vm.picture(lesson)}}),_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"flex-fill pr-2"},[_c('h6',[_vm._v(_vm._s(lesson.name))])]),(lesson.progress && lesson.progress.finished_at)?_c('div',{staticClass:"circle check"},[_c('img',{attrs:{"src":"https://img.icons8.com/metro/16/FFFFFF/checkmark.png"}})]):_vm._e()])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }